import { Box, Typography, Card, CardContent, Chip, Button, Link, Dialog, DialogTitle, DialogContent, DialogActions, TextField } from "@mui/material";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { format } from 'date-fns';
import { useState } from "react";
import AssignmentModal from "./AssignmentModal";
import OfferLetterDrawer from "./OfferLetterDrawer";
import { getAllOfferLetter, postOfferLetter, revokeTheoffer } from "../../../../Redux/Reducers/JobReducer";
import { useDispatch } from "react-redux";

const ViewRecruiterOfferLetter = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { applicant } = location.state || {}
    const offerLetters = useSelector((state) => state?.jobs?.AllOfferLetters?.offerLetter) || [];
    const navigate = useNavigate();
    const [openPdfModal, setOpenPdfModal] = useState(false);
  const [selectedOffer, setSelectedOffer] = useState(null);
  const [showOfferDrawer, setShowOfferDrawer] = useState(false);
  const [confirmDialog, setConfirmDialog] = useState(false);
const [revoking, setRevoking] = useState(false);
const [revocationRemarks, setRevocationRemarks] = useState('');
 const [viewType, setViewType] = useState('');
    console.log("applicantNNNNNNNN", applicant)
  
    const formatDate = (dateString) => {
      return format(new Date(dateString), 'dd MMMM yyyy');
    };
  
    const getStatusColor = (status) => {
      switch (status) {
        case 'Offer Released':
          return 'warning';
        case 'Offer Accepted':
          return 'success';
        default:
          return 'default';
      }
    };

    const handleViewOfferLetter = (offer,type) => {
      setSelectedOffer(offer);
      setViewType(type)
      setOpenPdfModal(true);
    };

    const handleResendOffer = () => {
      console.log("Resending offer for:", selectedOffer?.id);
      // Add your resend offer logic here
      setShowOfferDrawer(true);
    };

    const handleOfferSubmit = async (formData) => {
      try {
        const response = await dispatch(postOfferLetter(formData));
        if (response) {
          setShowOfferDrawer(false);
          // Refresh offer letters
          dispatch(getAllOfferLetter(applicant?.application_id));
        }
      } catch (error) {
        console.error("Error sending offer:", error);
      }
    };

    const handleRevokeOffer = (offerId) => {
      setSelectedOffer(offerId);
      setConfirmDialog(true);
    };
    
    // Add this new function to handle the actual revocation
    const handleConfirmRevoke = async () => {
      try {
        setRevoking(true);

        const payload = {
          application_id: applicant?.application_id,
          remarks: revocationRemarks,
        };
        const response = await dispatch(revokeTheoffer(payload));
        
        if (response) {
          // Refresh offer letters after successful revocation
          dispatch(getAllOfferLetter(applicant?.application_id));
        }
      } catch (error) {
        console.error("Error revoking offer:", error);
      } finally {
        setRevoking(false);
        setConfirmDialog(false);
        setSelectedOffer(null);
        setRevocationRemarks(''); // Reset remarks
      }
    };
  
    return (
      <Box sx={{  margin: '0 auto', p: 2, backgroundColor: '#f4f7fe', minHeight:"85vh" }}>
        {/* <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}> */}
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, mb: 4,  }}>
  {/* Top Buttons Row */}
  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
  <Button 
    startIcon={<ArrowBackIcon />} 
    onClick={() => navigate(-1)}
  >
    Back 
  </Button>
  <Box sx={{ display: 'flex', gap: 2 }}>
  <Button 
              variant="contained" 
              color="primary"
              onClick={handleResendOffer}
            >
              Resend Offer
            </Button>
  <Button 
              variant="contained" 
              color="error"
              onClick={() => handleRevokeOffer(selectedOffer?.id)}
            >
              Revoke Offer
            </Button>
  </Box>
  </Box>

  {/* Visiting Card */}
  {applicant && (
    <Card sx={{  maxWidth:"900px", display: 'flex', p: 2, alignItems: 'center', gap: 3, boxShadow: 3, justifyContent:"center" }}>
      {/* Profile Picture */}
      <Box
        component="img"
        src={applicant.profile_picture}
        alt={applicant.name}
        sx={{
          width: 80,
          height: 80,
          borderRadius: '50%',
          objectFit: 'cover'
        }}
      />

      {/* Applicant Info */}
      <Box sx={{ flex: 1 }}>
        <Typography variant="h6" fontWeight="bold">{applicant.name}</Typography>
        <Typography variant="body2" color="text.secondary">{applicant.role}</Typography>
        <Typography variant="body2" color="text.secondary" mt={1}>{applicant.email}</Typography>
        <Typography variant="body2" color="text.secondary">{applicant.phone}</Typography>
      </Box>

      {/* Company Info */}
      <Box sx={{ textAlign: 'right' }}>
        <Box
          component="img"
          src={applicant?.logo}
          alt={applicant?.company_name}
          sx={{
            width: 60,
            height: 60,
            objectFit: 'contain',
            borderRadius: 1,
            mb: 1
          }}
        />
        <Typography variant="subtitle2" fontWeight="medium">Company Name: {applicant?.company_name}</Typography>
      </Box>
    </Card>
  )}
</Box>

       
  
        {offerLetters?.map((offer) => (
          <Card sx={{ mb: 2, maxWidth:"900px", }} key={offer?.id}>
            <CardContent>
              <Box sx={{  display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, alignItems: 'center', mb: 3 }}>
                <Box sx={{ flex: 1 }}>
                  <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }} >
                  {/* <Typography variant="h5" sx={{ mb: 2 }}>Designation</Typography> */}
                  <Typography variant="h5" sx={{ mb: 2,  }}>{offer?.designation}</Typography>
                  </Box>
                  
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                {offer?.offer_letter_file && (
                <Button 
                  variant="contained" 
                  onClick={() => handleViewOfferLetter(offer, "Assignment")}
                >
                  View Offer Letter
                </Button>
              )}
                </Box>
              </Box>
  
              <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 3 }}>
                <Box>
                  <Typography variant="subtitle2" color="text.secondary">CTC</Typography>
                  <Typography variant="body1">₹{Number(offer?.ctc).toLocaleString()}</Typography>
                </Box>
               
                {/* <Box>
                  <Typography variant="subtitle2" color="text.secondary">Created By</Typography>
                  <Typography variant="body1">{offer?.created_by}</Typography>
                </Box> */}
                <Box>
                  <Typography variant="subtitle2" color="text.secondary">Created At</Typography>
                  <Typography variant="body1">{formatDate(offer?.created_at)}</Typography>
                </Box>
                <Box>
                  <Typography variant="subtitle2" color="text.secondary">Date of Joining</Typography>
                  <Typography variant="body1">{formatDate(offer?.date_of_joining)}</Typography>
                </Box>
                <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                    {/* <Chip 
                      label={offer?.status} 
                      color={getStatusColor(offer?.status)}
                    /> */}
                      <Typography variant="subtitle2" color="text.secondary">Status</Typography>
                      <Typography variant="body1">{offer?.status}</Typography>
                  </Box>
                {offer?.remarks && (
                  <Box sx={{ gridColumn: { md: '1 / -1' } }}>
                    <Typography variant="subtitle2" color="text.secondary">Remarks</Typography>
                    <Typography variant="body1">{offer?.remarks}</Typography>
                  </Box>
                )}
              </Box>
            </CardContent>
          </Card>
        ))}
        
  
        {offerLetters?.length === 0 && (
          <Typography variant="h6" sx={{ textAlign: 'center', mt: 4 }}>
            No offer letters found
          </Typography>
        )}

{selectedOffer && (
        <AssignmentModal
        viewType={viewType}
          openPdf={openPdfModal}
          onClose={() => {
            setOpenPdfModal(false);
            setSelectedOffer(null);
          }}
          application_id={selectedOffer?.id}
          assignment_file={selectedOffer?.offer_letter_file}
          assignment_file_type="application/pdf"
          submission_file={selectedOffer?.submission_file}
          submission_file_type={selectedOffer?.submission_file_type}
        />
      )}

<OfferLetterDrawer 
      open={showOfferDrawer}
      onClose={() => setShowOfferDrawer(false)}
      onSubmit={handleOfferSubmit}
      applicant={applicant}
    />

<Dialog
  open={confirmDialog}
  onClose={() => {
    setConfirmDialog(false);
    setRevocationRemarks('');
  }}
>
  <DialogTitle>Confirm Revocation</DialogTitle>
  <DialogContent>
    <Typography sx={{ mb: 2 }}>
      Are you sure you want to revoke this offer letter? This action cannot be undone.
    </Typography>
    <TextField
      fullWidth
      multiline
      rows={3}
      label="Revocation Remarks"
      value={revocationRemarks}
      onChange={(e) => setRevocationRemarks(e.target.value)}
      placeholder="Please provide a reason for revoking the offer"
      sx={{ mt: 2 }}
    />
  </DialogContent>
  <DialogActions>
    <Button 
      onClick={() => {
        setConfirmDialog(false);
        setRevocationRemarks('');
      }}
      color="primary"
    >
      No
    </Button>
    <Button 
      onClick={handleConfirmRevoke}
      color="error"
      variant="contained"
      disabled={revoking || !revocationRemarks.trim()}
    >
      {revoking ? "Revoking..." : "Yes, Revoke"}
    </Button>
  </DialogActions>
</Dialog>
      </Box>
    );
  };

export default ViewRecruiterOfferLetter;